import axios from "axios";
import config from "src/config";

const URLBFPUBLICKEY = config.url.URLBFPUBLICKEY;

export const BfkeyAPI = {
  async getBfKey() {
    try {
      const response = await axios.get(URLBFPUBLICKEY);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
}; 